import { saveSettings } from "@/controllers/auth";

// High-contrast display preference. Source of truth for signed-in users is
// the accessibility setting saved on the account (Settings > Accessibility >
// High Contrast), stored in module_settings under this key. localStorage
// mirrors it so the very first paint after a reload is already right.
//
// Deliberately NOT the legacy "HighContrast->/settings" key: that was a
// chart-only option (holders chart) that many accounts already have switched
// on, and reading it as the app-wide mode opted those users in unexpectedly.
export const CONTRAST_SETTING_MODULE = "HighContrastDisplay";
export const CONTRAST_SETTING_KEY = "HighContrastDisplay->/settings";
export const CONTRAST_STORAGE_KEY = "contrast";

export type Contrast = "normal" | "high";

export const readStoredContrast = (): Contrast => {
    try {
        return localStorage.getItem(CONTRAST_STORAGE_KEY) === "high" ? "high" : "normal";
    } catch (e) {
        return "normal";
    }
};

export const storeContrast = (value: Contrast) => {
    try {
        localStorage.setItem(CONTRAST_STORAGE_KEY, value);
    } catch (e) {
        /* storage unavailable */
    }
};

// Persist to the account (no-op for visitors) and mirror into the Recoil
// module-settings map so the Settings page reflects it immediately.
export const persistContrastSetting = (value: Contrast, isVisitor: boolean, setModuleSettings: (fn: (prev: { [key: string]: any }) => { [key: string]: any }) => void) => {
    const high = value === "high";
    setModuleSettings((prev) => ({ ...prev, [CONTRAST_SETTING_KEY]: { ...(prev?.[CONTRAST_SETTING_KEY] || {}), value: high } }));
    if (!isVisitor) saveSettings(CONTRAST_SETTING_MODULE, "/settings", { value: high }).catch(() => undefined);
};
